import request from '@/utils/request'

const prefix = '/django_rest/company/applicant-lock-config'

export default {
  getCompanyListCanConfig () {
    return request.get(`${prefix}/`)
  },
  getApplicantLockConfig (companyId, params) {
    return request.get(`${prefix}/${companyId}/`, { params })
  },
  createApplicantLockConfig (companyId, config) {
    return request.post(`${prefix}/${companyId}/`, config)
  },
  updateApplicantLockConfig (companyId, config) {
    return request.put(`${prefix}/${companyId}/`, config)
  },
  deleteApplicantLockConfig (companyId) {
    return request.delete(`${prefix}/${companyId}/`)
  }
}
